import styled from 'styled-components';
import ds from 'designsystem';

const Header5 = styled.h5`
    color: ${ds.brand('text')};
    font-size: ${ds.fs('base')};
    font-family: ${ds.get('type.fontFamily.text')};
    font-weight: ${({ bold }) => (bold ? ds.get('type.fontWeight.bold') : ds.get('type.fontWeight.regular'))};
    line-height: ${ds.get('type.lineHeight.base')};
`;

export default Header5;



// WEBPACK FOOTER //
// ./src/elements/Header5.js